import type { BookingTypeLabel } from '../types';

interface BookingTypeBadgeProps {
  type: BookingTypeLabel;
  /** 'overlay' = sobre foto (semi-transparente); 'inline' = inline em texto; 'large' = painel */
  variant?: 'overlay' | 'inline' | 'large';
}

/**
 * Badge unificado para os 2 tipos de reserva.
 *
 * Cor sistêmica:
 *  - Confirmação Imediata → verde (--success)
 *  - Sob Consulta         → âmbar (--warn)
 *
 * Variant 'overlay' aparece no card sobre a imagem.
 * Variant 'inline' usa em listas/headers.
 * Variant 'large' fica no topo do painel da página de detalhe.
 */
export function BookingTypeBadge({ type, variant = 'inline' }: BookingTypeBadgeProps) {
  const isInstant = type === 'Confirmação Imediata';
  const cls = `booking-type-badge booking-type-badge--${variant} booking-type-badge--${isInstant ? 'instant' : 'request'}`;

  return (
    <span className={cls}>
      <span className="booking-type-badge__dot" aria-hidden="true" />
      <span className="booking-type-badge__label">
        {isInstant ? 'Confirmação Imediata' : 'Sob Consulta'}
      </span>
    </span>
  );
}
